import { parseUnits } from 'viem';

const GAS = '5';

export const getGasPrice = async (provider) => {
  const gasPrice = await provider.getGasPrice();
  const convertGas = parseUnits(GAS, 'gwei');
  return gasPrice + convertGas;
};
